import axios from 'axios';
import { Dispatch } from 'redux';
import { errorHandler } from 'services/axiosService';

import { QContext, REACT_APP_QWEALTH_API_V3 } from '@qwealth/qdata';

import {
  AssignedWorkflow,
  AssignedWorkflowTemplateResponse,
  AssignedWorkflowsQueryParams,
  AvailableWorkflowTemplates,
  AvailableWorkflowsFilters,
} from 'data/models/Workflows';
import { mockAssignedWorkflowResponse } from 'data/refData/mockAssignedWorkflowResponse';
import { mockAssignedWorkflows } from 'data/refData/mockWorkflowData';

const availableWorkflowTemplates: AvailableWorkflowTemplates[] = [
  { uuid: '1', name: 'Onboarding', active: true },
  { uuid: '2', name: 'AAA', active: false },
  { uuid: '3', name: 'BBB', active: false },
  { uuid: '4', name: 'CCC', active: true },
  { uuid: '5', name: 'Annual Review', active: true },
  { uuid: '6', name: 'DDD', active: false },
  { uuid: '7', name: 'EEE', active: false },
  { uuid: '8', name: 'FFF', active: true },
  { uuid: '9', name: 'GGG', active: false },
  { uuid: '10', name: 'Compliance Check', active: true },
  { uuid: '11', name: 'III', active: false },
  { uuid: '12', name: 'JJJ', active: false },
  { uuid: '13', name: 'KKK', active: true },
  { uuid: '14', name: 'LLL', active: false },
  { uuid: '15', name: 'MMM', active: true },
  { uuid: '16', name: 'NNN', active: false },
  { uuid: '17', name: 'Test2', active: true },
];

export const fetchAvailableWorkflowTemplates = async (
  partnerId: number,
  dispatch: Dispatch,
  iaCode?: string,
): Promise<AvailableWorkflowTemplates[]> => {
  try {
    const filters = iaCode ? { partnerId, iaCode } : { partnerId };
    const mockAxiosGetAvailableWorkflowTemplates = async (filters: AvailableWorkflowsFilters): Promise<AvailableWorkflowTemplates[]> => {
      console.log(`Fetching Available Workflow Templates -> Partner Id: ${filters.partnerId} iaCode: ${filters.iaCode}`);
      const workflows = () => {
        if (partnerId === 2) {
          return availableWorkflowTemplates.slice(0, 9);
        } else {
          return availableWorkflowTemplates;
        }
      };
      return new Promise(resolve => {
        setTimeout(() => {
          resolve(workflows());
        }, 2000);
      });
    };

    const response = await mockAxiosGetAvailableWorkflowTemplates(filters);
    return response;
    //TODO: pending backend implementation
    // const response = await axios.get(`${REACT_APP_QWEALTH_API_V3}/availableWorkflowTemplates`, { params });
    // return response.data;
  } catch (e) {
    errorHandler(dispatch, 'API Error: Failed Fetching Available Workflow Templates')(e);
    return [];
  }
};

export const postAssignWorkflowTemplates = async (
  householdId: string,
  workflowTemplateIds: string[],
  dispatch: Dispatch,
): Promise<AssignedWorkflowTemplateResponse[] | undefined> => {
  try {
    const mockAxiosPostAssignWorkflowTemplates = async (
      householdId: string,
      workflowTemplateIds: string[],
    ): Promise<AssignedWorkflowTemplateResponse[]> => {
      console.log(`Assigning Workflow Templates -> Household Id: ${householdId} Workflow Template Ids: ${workflowTemplateIds}`);
      return mockAssignedWorkflowResponse;
    };

    const response = await mockAxiosPostAssignWorkflowTemplates(householdId, workflowTemplateIds);
    return response;
    //TODO: pending backend implementation
    // const response = await axios.post(`${REACT_APP_QWEALTH_API_V3}/assignWorkflowTemplate`, payload);
    // return response.data;
  } catch (e) {
    errorHandler(dispatch, 'API Error: Failed Assigning Workflow Templates')(e);
    return undefined;
  }
};

export const fetchAssignedWorkflows = async (queryParams: AssignedWorkflowsQueryParams, dispatch: Dispatch): Promise<AssignedWorkflow[]> => {
  try {
    const mockAxiosGetAssignedWorkflows = async (queryParams: AssignedWorkflowsQueryParams): Promise<AssignedWorkflow[]> => {
      console.log(`Fetching Assigned Workflows -> Filters: ${queryParams}`);
      return new Promise(resolve => {
        setTimeout(() => {
          resolve(mockAssignedWorkflows);
        }, 2000);
      });
    };

    const response = await mockAxiosGetAssignedWorkflows(queryParams);
    return response;
    //TODO: pending backend implementation
    // const response = await axios.get(`${REACT_APP_QWEALTH_API_V3}/assignedWorkflow`, { params });
    // return response.data;
  } catch (e) {
    errorHandler(dispatch, 'API Error: Failed Fetching Assigned Workflows')(e);
    return [];
  }
};

export const fetchAssignedWorkflow = async (workflowId: string, dispatch: Dispatch): Promise<AssignedWorkflow | undefined> => {
  try {
    const mockAxiosGetAssignedWorkflow = async (payload: string): Promise<AssignedWorkflow | undefined> => {
      console.log(`Fetching Assigned Workflow -> Workflow Id: ${payload}`);
      const data = mockAssignedWorkflows.find(workflow => workflow.uuid === payload);
      return new Promise(resolve => {
        setTimeout(() => {
          resolve(data);
        }, 2000);
      });
    };

    const response = await mockAxiosGetAssignedWorkflow(workflowId);
    return response;
    //TODO: pending backend implementation
    // const response = await axios.get(`${REACT_APP_QWEALTH_API_V3}/assignedWorkflow`, { params });
    // return response.data;
  } catch (e) {
    errorHandler(dispatch, 'API Error: Failed Fetching Assigned Workflow')(e);
    return undefined;
  }
};

export const patchAssignedWorkflow = async (assignedWorkflow: AssignedWorkflow, dispatch: Dispatch): Promise<AssignedWorkflow | undefined> => {
  try {
    const mockAxiosPatchAssignedWorkflow = async (payload: AssignedWorkflow): Promise<AssignedWorkflow> => {
      console.log(`Updating Assigned Workflow -> Workflow Id: ${payload.uuid}`);
      return {
        ...payload,
      };
    };

    const response = await mockAxiosPatchAssignedWorkflow(assignedWorkflow);
    return response;
    //TODO: pending backend implementation
    // const response = await axios.patch(`${REACT_APP_QWEALTH_API_V3}/assignedWorkflow`, payload);
    // return response.data;
  } catch (e) {
    errorHandler(dispatch, `API Error: Failed updating Workflow: ${assignedWorkflow.name}`)(e);
    return undefined;
  }
};

export const deleteAssignedWorkflow = async (assignedWorkflowId: string, dispatch: Dispatch): Promise<string | undefined> => {
  try {
    const mockAxiosDeleteAssignedWorkflow = async (payload: string): Promise<string> => {
      console.log(`Deleted Workflow -> Workflow Id: ${payload}`);
      return payload;
    };

    const response = await mockAxiosDeleteAssignedWorkflow(assignedWorkflowId);
    return response;
    //TODO: pending backend implementation
    // const response = await axios.delete(`${REACT_APP_QWEALTH_API_V3}/assignedWorkflow/${assignedWorkflowId}`);
    // return response.data;
  } catch (e) {
    errorHandler(dispatch, 'API Error: Failed Deleting Assigned Workflow')(e);
    return undefined;
  }
};
